export const emptyFunction = () => {
  // empty
};
